import type { StaticTextResource } from '../keys'

export const id: StaticTextResource = {
  'schedule.dueToday': 'Sebelum {{time}} hari ini',
  'schedule.dueTomorrow': 'Sebelum {{time}} besok',
  'schedule.durationRange':
    '{{start}} - {{end}} (Hari ke-{{currentDay}} / {{days}} hari)',
  'editReport.defaultPageName': 'Halaman {{n}}',
  'editReport.defaultSectionName': 'Bagian',
  'editReport.defaultRepeatSectionName': 'Bagian berulang',
}
